import * as svg from "../../../assets/radio-button-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const RadioButtonIcon = iconBuilder(svg, "RadioButtonIcon", "0 0 18 18");
